import httpClient from '@/api/http-client';

const endpoint = 'api/countries';

const countriesService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  update: (country) => httpClient.put(`${endpoint}/${country.id}`, country),
};

export default countriesService;
